import * as React from 'react';
import {
  IInfrastructureType,
  ALWAYS_VISIBLE_INFRASTRUCTURE_TYPES,
  INFRASTRUCTURE_MAP_ICON,
  trackInfrastructureTypeClick,
} from '../utils';
import { InfrastructureTypeItem, InfrastructureTypesLayout } from '../../../components/Infrastructure';

interface IInfrastructureMapTypesProps {
  fixed: boolean;
  currentTypes: string[];
  onTypesChange: (types: string[]) => void;
  types: IInfrastructureType[] | null;
}

export const InfrastructureMapTypes: React.FC<IInfrastructureMapTypesProps> = ({
  fixed,
  types,
  currentTypes,
  onTypesChange,
}) => {
  const handleChange = React.useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => {
      const type = event.currentTarget.getAttribute('data-type') as string;
      onTypesChange([...ALWAYS_VISIBLE_INFRASTRUCTURE_TYPES, type]);
      trackInfrastructureTypeClick(type);
    },
    [onTypesChange],
  );

  if (!types) {
    return null;
  }

  return (
    <InfrastructureTypesLayout fixed={fixed}>
      {types.map(({ title, type }, index) => {
        const checked = currentTypes.includes(type);
        const IconComponent = INFRASTRUCTURE_MAP_ICON[type];

        if (!IconComponent) {
          return null;
        }

        return (
          <InfrastructureTypeItem
            key={type + index}
            checked={checked}
            type={type}
            title={title}
            icon={<IconComponent color="icon-secondary-default" />}
            handleChange={handleChange}
          />
        );
      })}
    </InfrastructureTypesLayout>
  );
};
